import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowStep} from "../workflow-step";
import {WorkflowService} from "../workflow.service";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";
import {SiteService} from "../../sites/site.service";
import {SiteDetailModel, siteDetailModelFactory} from "../../sites/site-detail.model";

@Component({
  templateUrl: "./set-site-design-steps.template.pug",
  providers: [],
})
@exposeComponentInDebugMode()
export class SetSiteDesignStepsComponent extends WorkflowStep {
  error: Error;
  syncCdfDdl: boolean = false;
  syncCdfTl: boolean = false;
  addIndividualAssetsDdl: boolean = false;
  addIndividualAssetsTl: boolean = false;
  manualSiteDesignDdl: boolean = false;
  manualSiteDesignTl: boolean = true;
  site: SiteDetailModel = siteDetailModelFactory();

  public async ready() {
    this.error = undefined;

    const {
      syncCdfDdl,
      syncCdfTl,
      addIndividualAssetsDdl,
      addIndividualAssetsTl,
      manualSiteDesignDdl,
    } = this.workflowService.workflowConfig.flags;

    this.syncCdfDdl = syncCdfDdl;
    this.syncCdfTl = syncCdfTl;
    this.addIndividualAssetsDdl = addIndividualAssetsDdl;
    this.addIndividualAssetsTl = addIndividualAssetsTl;
    this.manualSiteDesignDdl = manualSiteDesignDdl;
    const siteId = this.workflowService.workflowConfig.targetId;
    this.site = await this.siteService.getSiteById(siteId);
  }

  public setFlag(flag) {
    this.workflowService.setWorkflowFlag(flag, this[flag] || null);
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private siteService: SiteService,
  ) {
    super();
  }
}
